// extracted by mini-css-extract-plugin
export default {"anchor":"Anchor_anchor__M1nw+","anchorNone":"Anchor_anchorNone__U5F6n"};